import React, {useState} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    changeWallet, changeWalletFailure,
    setSettingsChangeWalletModalStatus
} from "../../../store/cabinet/action";
// import {toast} from "react-toastify";

const CabinetSettingsChangeWalletModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const settingsChangeWalletModalStatus = useSelector(store => store.cabinet.settingsChangeWalletModalStatus);
    const userData = useSelector(store => store.cabinet.userData);
    const formErr = useSelector(store => store.cabinet.changeWalletStatusErr);
    const changeWalletStatusStarted = useSelector(store => store.cabinet.changeWalletStatusStarted);


    const [wallet_address, setWalletAddress] = useState('');

    const closeModal = () => {
        setWalletAddress('');
        dispatch(setSettingsChangeWalletModalStatus(false));
    };

    const isSubmitSuccess = () =>{
        return !changeWalletStatusStarted
    }

    const successHandler = () =>{
        // toast(t('Ваш кошелек успешно обновлен!'));
        closeModal();
    }

    const sendFormHandler = () =>{
        if (isSubmitSuccess()) {
            dispatch(changeWallet({wallet_address}, successHandler));
        }
    }

    return (
        <Popup
            open={settingsChangeWalletModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div />
                    <div />
                </div>

                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>
                        {userData?.user?.wallet_address ? t('Изменить кошелек') : t("Добавить кошелек")}
                    </div>

                    <div className={Styles.inputWrap}>
                        <div className={`${Styles.inputBox} ${formErr?.wallet_address ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Адрес кошелька')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="text"
                                placeholder="0x…"
                                value={wallet_address}
                                onChange={(e)=>{setWalletAddress(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.wallet_address){
                                        delete formErr.wallet_address;
                                        dispatch(changeWalletFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.wallet_address ? Styles.tcErrActive : null}`}>{formErr?.wallet_address ? formErr.wallet_address : null}</div>
                        </div>
                    </div>
                    <div className={Styles.note}>
                        {t('Введите адрес кошелька в сети BNB Smart Chain (BEP-20). На этот адрес будут начислены токены.')}
                    </div>
                    <div className={`${Styles.tcBtn}`} onClick={()=>{sendFormHandler()}}>{t('Сохранить')}</div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetSettingsChangeWalletModal;
